import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useInView, useAnimation } from "framer-motion";
import { getCaseStudyHomePreview } from "../../../utils/caseStudyUtils";
import CaseStudyCardOverlay from "./caseStudyCardOverlay";

const CaseStudyColumn = ({ casestudy }) => {
  const { id } = casestudy;
  const { title } = getCaseStudyHomePreview(casestudy);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const mainControls = useAnimation();

  useEffect(() => {
    if (isInView) {
      mainControls.start("visible");
    }
  }, [isInView, mainControls]);

  return (
    <Link to={`/clients/${id}`} className="grid-item">
      <motion.img
        variants={{
          hidden: { opacity: 0, x: 75 },
          visible: { opacity: 0.5, x: 0 },
        }}
        initial="hidden"
        animate={mainControls}
        transition={{ duration: 1.5 }}
        ref={ref}
        src={casestudy.image}
        alt={title}
      />
      <CaseStudyCardOverlay casestudy={casestudy} />
    </Link>
  );
};

export default CaseStudyColumn;
